import Validator from 'validatorjs'
import formatErrors from './formatErrors'
import moment from 'moment-jalaali'

const rules = {
  birthday: 'isMoment',
  email: 'required|email',
  full_name: 'string',
  gender: 'string',
  mobile: 'required|numeric',
  phone: 'numeric'
}

Validator.register('isMoment', (value) => {
  let beginCentury = moment('1300-01-01', 'jYYYY-jMM-jDD')
  let thisYear = moment()
  return moment(value, 'jYYYY-jMM-jDD').isBetween(beginCentury, thisYear)
}, 'تاریخ تولد در محدود مجاز نمی‌باشد')

export default function validateUser (values) {
  const validator = new Validator(values, rules, {
    required: 'این فیلد الزامی است',
    email: 'فرمت ایمیل صحیح نمی باشد',
    numeric: 'این فیلد می‌بایست عدد باشد',
    date: 'تاریخ صحیح نمی باشد'
  })
  validator.passes()
  return formatErrors(validator.errors.all())
}



// WEBPACK FOOTER //
// ./src/utils/validateProfile.js